import PostModal, { PostModalProps } from './PostModal'
import ButtonModal, { Modal, ModalProps } from './components/ButtonModal'
import TableLinkCell from './components/TableLinkCell'
import ModalManagement from './components/ModalManagement'
import ModalCheckbox from './components/ModalCheckbox'
import './PostModal.scss'

export type { ModalProps, PostModalProps }
export { ButtonModal, Modal, TableLinkCell, ModalManagement, ModalCheckbox }
export default PostModal